'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _DescriptionTextBlock = require('./DescriptionTextBlock.scss');var styles = _interopRequireWildcard(_DescriptionTextBlock);
var _constants = require('../../constants');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Styles
var DescriptionTextBlock = function (_Component) {_inherits(DescriptionTextBlock, _Component);function DescriptionTextBlock() {var _temp, _this, _ret;_classCallCheck(this, DescriptionTextBlock);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      descriptionIsOpen: false,
      isDifferenceHight: false,
      isWillMoreText: false }, _this.













    calcHeightContent = function () {
      var content = _this.contentWrapper;
      var contentHeight = content.getBoundingClientRect().height;
      var parentHeight = content.parentNode.getBoundingClientRect().height;

      var isWillMoreText = contentHeight >= _constants.DEFAULT_DESCRIPTION_LENGTH;
      var isDifferenceHight = contentHeight <= parentHeight;

      _this.setState({ isDifferenceHight: isDifferenceHight, isWillMoreText: isWillMoreText });
    }, _this.

    handleClickMoreButton = function (evt) {
      evt.preventDefault();
      _this.toggleDescription(!_this.state.descriptionIsOpen);
    }, _this.

    toggleDescription = function (status) {return _this.setState({ descriptionIsOpen: status });}, _this.


    renderMoreButton = function () {return (
        _react2.default.createElement('button', { onClick: _this.handleClickMoreButton },
          _this.props.translate('SEOsearch', _this.state.descriptionIsOpen ? 'hide' : 'showMore')));}, _temp), _possibleConstructorReturn(_this, _ret);}DescriptionTextBlock.prototype.componentDidMount = function componentDidMount() {this.calcHeightContent();};DescriptionTextBlock.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextState) {var openStateIsChanged = nextState.descriptionIsOpen !== this.state.descriptionIsOpen;var openDifferenceHight = nextState.isDifferenceHight !== this.state.isDifferenceHight;var localeIsChanged = nextState.locale !== this.props.locale;return openStateIsChanged || localeIsChanged || openDifferenceHight;};DescriptionTextBlock.prototype.



  render = function render() {var _cx,_cx2,_cx3,_this2 = this;
    var TitleTag = this.props.titleTag || 'div';var _props =
    this.props,translate = _props.translate,isTranslate = _props.isTranslate,descriptionData = _props.descriptionData,toggleDescriptionTranslation = _props.toggleDescriptionTranslation;

    return (
      // eslint-disable-next-line max-len
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.wrapText, this.props.className, (_cx = {}, _cx[styles.withOutButton] = this.state.isDifferenceHight, _cx[styles.willMoreText] = this.state.isWillMoreText, _cx)) },
        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.titleWrapper, (_cx2 = {}, _cx2[
            styles.translate] = isTranslate && descriptionData.translatedRequired, _cx2)) },

          _react2.default.createElement(TitleTag, { className: styles.title },

            this.props.isTitleTranslated ?
            this.props.title :
            this.props.translate('companyPage', this.props.title)),


          isTranslate && descriptionData.translatedRequired &&
          _react2.default.createElement('div', { className: styles.translateDescriptionRow },
            _react2.default.createElement('button', {
                className: styles.showOriginalDescription,
                onClick: toggleDescriptionTranslation },

              _react2.default.createElement('span', null,
                translate('propertyDetails', 'multilingualDescription', descriptionData.showOriginal ?
                'showOriginalDescription' :
                'returnTranslation')), '\xA0',



              _react2.default.createElement('sub', null, 'Powered by Google')))),




        _react2.default.createElement('div', { className: (0, _classnames2.default)((_cx3 = {}, _cx3[styles.opened] = this.state.descriptionIsOpen, _cx3)) },
          _react2.default.createElement('pre', { id: 'pre', ref: function ref(_ref) {_this2.contentWrapper = _ref;} },
            this.props.contentText)),


        !this.state.isDifferenceHight && this.renderMoreButton()));


  };return DescriptionTextBlock;}(_react.Component);


DescriptionTextBlock.propTypes = {
  className: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  contentText: _propTypes2.default.string,
  title: _propTypes2.default.string,
  isTitleTranslated: _propTypes2.default.bool,
  titleTag: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  toggleDescriptionTranslation: _propTypes2.default.func,
  description: _propTypes2.default.object,
  descriptionData: _propTypes2.default.object,
  isTranslate: _propTypes2.default.bool };exports.default =


DescriptionTextBlock;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DescriptionTextBlock/DescriptionTextBlock.js
// module id = 1203
// module chunks = 0